import Button from "@rio-cloud/rio-uikit/Button";
import Dialog from "@rio-cloud/rio-uikit/Dialog";

export type ExportStage = "collect" | "writing" | "done" | "error";

const stageLabel: Record<ExportStage, string> = {
  collect: "Coletando dados",
  writing: "Gerando arquivo",
  done: "Concluído",
  error: "Erro ao exportar",
};

interface ExportProgressKanbanDialogProps {
  show: boolean;
  stage: ExportStage;
  progress: number;
  detail?: string;
  onClose: () => void;
  errorMessage?: string;
}

export default function ExportProgressKanbanDialog({
  show,
  stage,
  progress,
  detail,
  onClose,
  errorMessage,
}: ExportProgressKanbanDialogProps) {
  return (
    <Dialog
      show={show}
      title="Exportando planilha"
      subtitle={detail ? `${stageLabel[stage]} — ${detail}` : stageLabel[stage]}
      footer={
        <Button onClick={onClose} className="btn btn-primary" bsSize="lg">
          Fechar
        </Button>
      }
      body={
        <div className="w-full mx-auto bg-white rounded-lg p-6">
          <div className="mb-2 text-size-14 text-color-black">Progresso</div>
          <div className="h-3 w-full rounded bg-gray-200 overflow-hidden">
            <div
              className="h-3 bg-[#27AE60]"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>
          <div className="mt-2 text-right text-size-12 text-color-black">
            {Math.round(progress)}%
          </div>
          {stage === "error" && (
            <div className="mt-4 text-size-14 text-color-danger">
              {errorMessage || "Algo deu errado ao gerar a planilha."}
            </div>
          )}
        </div>
      }
      onCloseValidation={() => {
        onClose();
        return true;
      }}
      className="dialog-export-progress"
      showCloseButton
    />
  );
}
